module.exports = __webpack_public_path__ + "static/media/crehana.e1f7db2c.svg";